<style></style>

<template>
    <div class="my_progress">
        <h2 class="lighter">
            My Self-Assessments
        </h2>
        <div
            v-for="module in modules"
            :key="module.id"
            class="mt-2"
        >
            <h3 class="lighter text-primary">
                {{module.module.name}}
            </h3>
            <module-assessments-chart 
                :assessments="module.responses"
                :module="module"
                v-if="module.responses.length > 0"
                :survey-cutoffs="surveyCutoffs"
            ></module-assessments-chart>
            <div class="alert alert-info" v-else>You have not completed any assessments in {{ module.module.name }}</div>
        </div>

        <div ></div>
        <h2 class="lighter mt-5 border-0 mb-2">My Completed Goals</h2>
        <div 
            v-if="actionPlans.length > 0"
            class="action-plan-list border-info" 
            style="border: solid 1px; border-radius: 10px; padding: 1em"
        >
            <div v-for="actionPlan in actionPlans" :key="actionPlan.id" class="border-bottom">
                <action-plan-list-item
                    :action-plan="actionPlan"
                    :module="actionPlan.goal.best_practice.module"
                ></action-plan-list-item>
            </div>
        </div>
        <div class="alert alert-info"
            v-else
        >You have not yet completed any goals.</div>
    </div>
</template>

<script>
    import ModuleAssessmentsChart from './ModuleAssessmentsChart'
    import ActionPlanListItem from '../action_plans/ActionPlanListItem'
    import _ from 'lodash';
    export default {
        components: {
            ModuleAssessmentsChart,
            ActionPlanListItem
        },
        props: {
            modules: {
                required: true,
            },
            surveyCutoffs: {
                required: true,
                type: Object
            }
        },
        data() {
            return {}
        },
        computed: {
            actionPlans: function () {
                return _.flatten(this.modules.map(mod => mod['action plans'])).filter(ap => ap.date_completed !== null);
            }
        }    
    }
</script>